import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const HeroSection = () => {
  const scrollToAI = () => {
    document.querySelector('#ai-interaction')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative flex items-center justify-center overflow-hidden py-8 sm:py-10 md:py-12">
      <div className="relative max-w-[745px] w-full mx-auto px-4 sm:px-6 py-6 sm:py-8">
        {/* Content - Single Column Layout */}
        <div className="space-y-6 sm:space-y-8 animate-fade-in">
          {/* UAE Badge */}
          <div className="inline-flex items-center space-x-2 px-3 py-1.5 bg-primary/10 rounded-full border border-primary/20">
            <span className="text-lg">🇦🇪</span>
            <span className="text-xs font-medium text-primary">Made in UAE</span>
          </div>

          {/* Headline */}
          <div className="space-y-3 sm:space-y-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
              The UAE's own
              <span className="block text-primary mt-2">
                Workplace Intelligence Platform
              </span>
            </h1>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-2xl">
              Reshape your workplace. <span className="emphasize-accent">Empower your people.</span> Built for the modern workforce.
            </p>
          </div>

          {/* Value Props */}
          <div className="space-y-3">
            {[
              { text: 'End-to-end workplace management from ', highlight: 'day one to beyond' },
              { text: 'AI-powered people insights & ', highlight: 'workforce analytics' },
              { text: 'Employee experience that drives ', highlight: 'engagement & retention' },
            ].map((item, index) => (
              <div key={index} className="flex items-start space-x-2">
                <CheckCircle2 className="w-5 h-5 text-success flex-shrink-0 mt-0.5" />
                <span className="text-sm sm:text-base text-foreground">
                  {item.text}<span className="emphasize font-semibold">{item.highlight}</span>
                </span>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2">
            <Button
              size="lg"
              onClick={scrollToAI}
              className="bg-accent hover:bg-accent/90 text-accent-foreground text-sm sm:text-base px-6 sm:px-8 h-11 sm:h-12 group"
            >
              Ask hirerkey AI
              <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => document.querySelector('#modules')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 text-sm sm:text-base px-6 sm:px-8 h-11 sm:h-12"
            >
              Explore Platform
            </Button>
          </div>

          {/* Legal info */}
          <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed pt-2">
            hirerkey<sup>TM</sup> is a registered brand under KSM Emirates Group LLC FZ.
            <br />
            Meydan Grandstand, Meydan Road, Nad Al Sheba, Dubai, UAE.
          </p>

          {/* Hero Image */}
          <div className="relative pt-6 sm:pt-8 animate-fade-in">
            <div className="relative max-w-3xl mx-auto">
              <div className="relative rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_workforce-transform/artifacts/vi15zljp_ECBE9A%20%281%29.png"
                  alt="hirerkey Platform Preview"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
